export default __webpack_public_path__ + "static/media/alcohol-placeholder.36e05a3d.svg";